import React, { Component } from 'react';
import { string, array, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import DescriptionItem from './DescriptionItem';
import styles from './BenefitsBanner.css';

const cx = classnames.bind(styles);

export default class BenefitsBanner extends Component {
  static propTypes = {
    title: string.isRequired,
    highlighted: string,
    subtitle: string.isRequired,
    className: string,
    items: array.isRequired,
    colorScheme: oneOf([
      'lb01',
      'lb02',
      'lb03'
    ])
  }

  static defaultProps = {
    colorScheme: 'lb01'
  }

  render() {
    const { title, subtitle, items, className, highlighted, colorScheme } = this.props;

    return (
      <div className={cx('mainWrapper', colorScheme, className)}>
        <div className={cx('titlesSection', 'flex')}>
          <div>
            <h3 className={cx('title')}>
              <span className={cx('highlighted')}>{highlighted}</span>
              &nbsp;{title}
            </h3>
            </div>
          <div>
            <h4 className={cx('subtitle')}>{subtitle}</h4>
          </div>
        </div>


        <ul className={cx('itemsList', 'flex flex-wrap')}>
          { items.map((item, i) => (
            <li key={`description-${i}`}>
              <DescriptionItem {...item}/>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/components/Banner/BenefitsBanner/BenefitsBanner.js